import React, {Component} from 'react';
import {createFragmentContainer, graphql} from 'react-relay';
import ReactHighcharts from 'react-highcharts';
import {injectIntl} from 'react-intl';
import {
  tntBlue,
  tntOrange,
  tntPurple,
  tntYellow,
  tntPink,
  tntTeal,
} from '../../theme/tntColors';

const styles = {
  wrapper: {
    padding: 5
  },
};

@injectIntl
class WordCloud extends Component {
  render() {
    const intl = this.props.intl;
    const wordCounts = this.props.answersReport ? this.props.answersReport.wordCounts : [];

    const data = wordCounts.map(obj => {
      return {
        name: obj.word,
        weight: obj.count,
      };
    });

    const chartConfig = {
      title: null,
      chart: {
        height: this.props.height-(styles.wrapper.padding*2),
        width: this.props.width-(styles.wrapper.padding*2),
      },
      plotOptions: {
        wordcloud: {
          colors: [
            tntBlue,
            tntOrange,
            tntPurple,
            tntYellow,
            tntPink,
            tntTeal,
          ],
        },
      },
      series: [{
        type: 'wordcloud',
        data: data,
        name: intl.formatMessage({id: 'occurrences'}),
      }],
    };

    if (data.length > 0) {
      return (
        <div style={styles.wrapper}>
          <ReactHighcharts
            config={chartConfig}
            domProps={{id: this.props.uniqueId}}
          />
        </div>
      );
    } else {
      return null;
    }
  }
}

export default createFragmentContainer(
  WordCloud,
  graphql`
    fragment WordCloud_answersReport on AnswersReport {
      wordCounts {
        word
        count
      }
    }
  `,
);



// WEBPACK FOOTER //
// ./src/components/WordCloud/WordCloud.js